import { useContext } from "react"
import { SearchbarContext } from "./../components/organisms/search-bar/search-bar.context"
import type { ISearchbarContext } from "./../components/organisms/search-bar/search-bar.context"

export function useSearch(): ISearchbarContext {
  const context: ISearchbarContext | null = useContext<ISearchbarContext | null>(SearchbarContext)

  return context!
}
